<template>
  <div>
    <div class="timer">{{ timeInSeconds | timer }}</div>
  </div>
</template>

<script>
export default {
  name: "Timer",
  data () {
    return {
      timeInSeconds: 300
    }
  },
  filters: {
    timer (value) {
      let sec_num = parseInt(value, 10);
      let minutes = Math.floor(sec_num / 60);
      let seconds = sec_num - (minutes * 60);
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return `${minutes}:${seconds}`
    }
  },
  mounted () {
    this.start()
    this.$bus.$on('start-timer', (value) => {
      this.timeInSeconds = value
    })
  },
  methods: {
    start () {
      setInterval(() => {
        if (this.timeInSeconds > 0) {
          this.timeInSeconds--
        } else {
          this.timeInSeconds = 0
          this.$emit('endTimer')
          clearInterval(this.timeInSeconds)
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.timer {
  font-size: 24px;
  color: #000;
}
</style>
